import * as types from '../mutation-types';
import {unionState, toDateTimeString} from '../helpers';

const state = () => ({
	customPages: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/custom-pages').then(response => {
			commit(types.STORE_CUSTOM_PAGES, response.data);
		});
	},

	create({commit}, {title, content, slug, in_navbar, images, main_image}) {
		const formData = new FormData();
		formData.append('title', title);
		formData.append('content', content);
		formData.append('slug', slug);
		formData.append('in_navbar', in_navbar ? 1 : 0);

		for (let image of images)
			formData.append('images[]', image);

		formData.append('main_image', main_image);

		return axios.post('/api/custom-pages', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_CUSTOM_PAGE, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/custom-pages/${id}`).then(response => {
			commit(types.STORE_CUSTOM_PAGE, response.data);
			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/custom-pages/${id}`).then(() => {
			commit(types.DELETE_CUSTOM_PAGE, id);
		});
	},

	restore({commit}, {id}) {
		return axios.patch(`/api/custom-pages/${id}`).then(() => {
			commit(types.RESTORE_CUSTOM_PAGE, id);
		});
	},

	update({commit}, {id, title, content, slug, in_navbar, images, main_image}) {
		const formData = new FormData();
		formData.append('title', title);
		formData.append('content', content);
		formData.append('slug', slug);
		formData.append('in_navbar', in_navbar ? 1 : 0);
		formData.append('_method', 'PUT');

		for (let image of images)
			formData.append('images[]', image);
		
		if (main_image)
			formData.append('main_image', main_image);
		
		return axios.post(`/api/custom-pages/${id}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_CUSTOM_PAGE, response.data);

			return response.data;
		});
	},
};

const mutations = {
	[types.STORE_CUSTOM_PAGES](state, customPages) {
		state.customPages = unionState(state.customPages, customPages);
	},

	[types.STORE_CUSTOM_PAGE](state, customPage) {
		state.customPages = unionState(state.customPages, [customPage]);
	},

	[types.DELETE_CUSTOM_PAGE](state, id) {
		const customPage = state.customPages.find(p => p.id === id);
		customPage.deleted_at = toDateTimeString(new Date());
	},

	[types.RESTORE_CUSTOM_PAGE](state, id) {
		const customPage = state.customPages.find(p => p.id === id);
		customPage.deleted_at = null;
	}
};

const getters = {
	getById: state => id => state.customPages.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};